
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorials",
      function () {
        return require("private-next-pages/editorials/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorials"])
      });
    }
  